export const FETCH_COMMON_CONFIG = "FETCH_COMMON_CONFIG";
export const FETCH_COMMON_CONFIG_PENDING = "FETCH_COMMON_CONFIG_PENDING";
export const FETCH_COMMON_CONFIG_REJECTED = "FETCH_COMMON_CONFIG_REJECTED";
export const FETCH_COMMON_CONFIG_FULFILLED = "FETCH_COMMON_CONFIG_FULFILLED";
